import { render } from "./InventoriesPage.vue?vue&type=template&id=080ea7ab&scoped=true"
import script from "./InventoriesPage.vue?vue&type=script&lang=js"
export * from "./InventoriesPage.vue?vue&type=script&lang=js"

import "./InventoriesPage.vue?vue&type=style&index=0&id=080ea7ab&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080ea7ab"]])

export default __exports__